const about = [
    {
        sectionId: "about",
        language: "en",
        title: "Matheus Dalmas Affonso",
        subtitle: "Fullstack Developer",
        content: {
            intro: "Hello! My name is Matheus. Nice to meet you. I'm a fullstack developer focused on web applications. In the menu, you will find links with information about my projects and how to contact me.",
            extra: "I was born in 1987, grew up in Porto Alegre, capital city of the state of Rio Grande do Sul, on the southernmost region of Brazil. I was a web developer before even ASP.NET was a thing! And I have done it for quite a while, until I got into Law school. Yes! I'm also a lawyer! Have been one for almost 10 years now. But if I'm being completely honest, I find a lot more joy in web development. That's why I went back to it."
        },
    },
    {
        sectionId: "about",
        language: "pt",
        title: "Matheus Dalmas Affonso",
        subtitle: "Desenvolvedor Fullstack",
        content: {
            intro: "Olá! Meu nome é Matheus. Prazer em conhecer você. Eu sou um desenvolvedor fullstack focado em aplicações para web. No menu, você encontrará links contendo informações sobre os meus projetos, além de meios para entrar em contato comigo.",
            extra: "Eu nasci em 1987, cresci em Porto Alegre, capital do estado do Rio Grande do Sul. Eu era desenvolvedor de web antes mesmo de ASP.NET existir! E eu programei por um tempo considerável, até entrar na faculdade de Direito. Sim! Eu também sou advogado! Há quase 10 anos já. Mas, sendo sincero, desenvolvimento de web permanece sendo a minha paixão. Por esse motivo que eu voltei a programar."
        },
    }
]

export default about